import React from "react";
import { useSelector } from "react-redux";
import GoogleChart, { commonOptions } from "../../../../../components/googleChart/googleChart";

const PieCharts = () => {
  const pieCharts = useSelector((state) => state.attritionAndCancelReasons.pieCharts);
  if (!pieCharts) return null;

  if (pieCharts)
    return pieCharts.map(({ data_table: { cols, rows }, options }, index) => (
      <div key={index} className="section__el pie-chart">
        {rows.length ? (
          <GoogleChart
            width={675}
            height={300}
            chartType="PieChart"
            columns={cols}
            rows={rows}
            options={{ ...commonOptions, ...options }}
            showCurrency={false}
            showAdditionTooltip={false}
            showXLSX={false}
          />
        ) : (
          <p className="error">No data available</p>
        )}
      </div>
    ));
};

export default PieCharts;
